import _ from 'lodash'
import moment from 'moment'

const _DATE_FROM = moment().subtract(5, 'y')
const _DATE_TO = moment()
const _DATE_DUR = moment.duration(_DATE_TO.diff(_DATE_FROM)).asDays()

const FIRSTNAMES_M = [
  'Alexander',
  'August',
  'Armin',
  'Ben',
  'Daniel',
  'Dieter',
  'Frank',
  'Karl',
  'Leon',
  'Luca',
  'Lukas',
  'Hans',
  'Heinz',
  'Friedrich',
  'Tim',
  'Thomas',
  'Thorsten',
  'Otto',
  'Wilfried'
]
const FIRSTNAMES_F = [
  'Monika',
  'Marie',
  'Laura',
  'Lena',
  'Katharina',
  'Katrin',
  'Michele',
  'Anna',
  'Anne',
  'Julia',
  'Astrid',
  'Dagmar',
  'Doris',
  'Hannelore',
  'Herta',
  'Karin',
  'Sabine',
  'Sybille'
]
const LASTNAMES = [
  'Fritz',
  'Weber',
  'Krüger',
  'Taucher',
  'Becker',
  'Fischer',
  'Hoffmann',
  'Huber',
  'Richter',
  'Maurer',
  'Meier',
  'Mueller',
  'Schulz',
  'Schneider',
  'Stein',
  'Wolf'
]
// const COMPANY_1 = ['Stahl', 'Schrott', 'Handelsbetrieb', 'Fertigungsstätte']
// const COMPANY_2 = ['Schröder', 'Peters', 'Frohning', 'Elbhausen']
// const COMPANY_3 = ['& Co.KG', 'GmbH', 'AG', 'und Sohn']
const STREET_1 = [
  'Bach',
  'Friesen',
  'Berg',
  'Blumen',
  'Burg',
  'Feld',
  'Haupt',
  'Märchen',
  'Muster',
  'Silber',
  'Wiesen'
]
const STREET_2 = ['gasse', 'strasse', 'weg']
const CITY = [
  'Aachen',
  'Bamberg',
  'Dortmund',
  'Magdeburg',
  'Bremen',
  'Mannheim',
  'Düsseldorf',
  'Essen',
  'Hamburg',
  'Köln',
  'München',
  'Wuppertal'
]
const ZIPCODES = ['44339', '19406']

const _gangsta = []
// Initialize "Gangsta"
_gangsta[0] =
  "Lorizzle boom shackalack dolor funky fresh daahng dawg, owned adipiscing elit. Nullizzle fo shizzle mah nizzle fo rizzle, mah home g-dizzle velizzle, gangster the bizzle, rizzle ghetto, pimpin' vizzle, dope. Pellentesque izzle tortor. Sizzle erizzle. Fusce dolizzle dapibizzle dizzle tempizzle shizzlin dizzle. Maurizzle pellentesque nibh get down get down turpizzle. Ma nizzle izzle tortor. Pellentesque eleifend break yo neck, yall stuff. In dang habitasse platea dictumst. Rizzle dapibizzle. Curabitizzle tellus urna, nizzle that's the shizzle, that's the shizzle ac, we gonna chung vitae, nunc. Go to hizzle suscipit. Integer sempizzle the bizzle sizzle stuff."
_gangsta[1] =
  "Gangsta izzle diam you son of a bizzle mah nizzle mollizzle. Izzle i'm in the shizzle. Morbi odio. Vivamus neque. Cras boom shackalack. Crizzle maurizzle shiznit, interdum dang, feugiat gangster amizzle, malesuada izzle, bow wow wow. Pellentesque gravida. Vestibulizzle shiz mi, yo mamma izzle, ass sed, fizzle boofron, velit. Cras in ipsizzle. Pot volutpizzle felizzle vel pimpin'. Crizzle stuff crunk in purizzle sodalizzle ornare. Shizzle my nizzle crocodizzle venenatizzle justo izzle shit. Nunc daahng dawg. Suspendisse venenatis we gonna chung mammasay mammasa mamma oo sa. Curabitur check out this away. Fo shizzle sizzle, leo eu dapibus hendrerit, fizzle felizzle rizzle sem, sure fo shizzle magna felis gizzle pede. Mammasay mammasa mamma oo sa a pot. Rizzle aptent taciti i saw beyonces tizzles and my pizzle went crizzle izzle litora torquent boofron shizznit shit, pizzle fo shizzle mah nizzle fo rizzle, mah home g-dizzle hymenizzle. Aliquizzle interdizzle, yo nizzle sure fo shizzle, nisl ma nizzle check out this leo, in semper risus arcu gangsta sizzle."
_gangsta[2] =
  "Sheezy nizzle mi nizzle cool posuere bibendum. Aliquam black things own yo'. Crizzle izzle shiz sheezy leo sodales euismod. Funky fresh stuff, maurizzle check it out dapibus convallizzle, nulla pizzle uhuh ... yih! metizzle, bizzle venenatizzle check out this dui in rizzle. Mah nizzle gravida lacizzle id check out this. Vivamizzle dawg shit, fermentum sizzle amet, faucibizzle i saw beyonces tizzles and my pizzle went crizzle, gizzle shiznit, doggy. Sed vehicula laoreet nibh. Vestibulum erizzle phat, hendrerizzle ma nizzle, condimentizzle ac, check out this a, arcu. Boom shackalack aliquizzle placerat nulla. Maecenizzle malesuada tellivizzle id hizzle. Dope metus sem, egestas eu, accumsizzle quis, elementum gangsta, neque. Nulla iaculizzle nunc owned orci i saw beyonces tizzles and my pizzle went crizzle sodalizzle. Ass sagittizzle, nulla shiz ghetto mollizzle, lacizzle quam dawg erizzle, phat bling bling augue mammasay mammasa mamma oo sa vitae arcu. You son of a bizzle vehicula lacus. Nunc nizzle gizzle. Fizzle eu turpizzle. Rizzle a magna. Nizzle turpis erat, consectetuer shizzlin dizzle, cool ass, facilisizzle in, bow wow wow. Nunc tellizzle. Bling bling nisi eros, things rizzle doggy, shiznit izzle, tincidunt non, augue."
_gangsta[3] =
  "Sizzle ullamcorper. Uhuh ... yih! sagittizzle the bizzle a maurizzle. Break it down ante shizzlin dizzle dope izzle hizzle bow wow wow luctizzle own yo' ultrices fo shizzle cubilia Mah nizzle; Funky fresh . Pellentesque its fo rizzle morbi shit its fo rizzle dawg doggy izzle malesuada fames away turpis egestas. Donec tempizzle dawg velit. Aliquam ghetto volutpat. Vivamizzle tortor enizzle, scelerisque ac, phat a, shut the shizzle up vizzle, arcu. Nulla elit. Donizzle fermentum, fo at pharetra ass, magna erat ultricizzle neque, nizzle urna dolizzle quizzle nibh. Vivamus tellizzle neque, sizzle izzle, shizzle my nizzle crocodizzle at, tellivizzle nizzle, sheezy. Praesent purus break yo neck, yall, bibendizzle sit cool, interdizzle vehicula, fizzle nizzle, arcu. Bling bling eget ipsum at est ullamcorpizzle black. Donec quam. Mauris ligula urna, shiz izzle, bow wow wow venenatizzle, pizzle nizzle, gangster. Etiam gravida."
_gangsta[4] =
  "Izzle tellus lorem, you son of a bizzle izzle, shizzlin dizzle fo shizzle my nizzle, vehicula izzle, fo shizzle. Etizzle shiznit fo shizzle mah nizzle fo rizzle, mah home g-dizzle gangster sem brizzle mattizzle. Pellentesque interdum magna izzle eros commodo black. Break yo neck, yall lobortis fermentum pimpin'. Morbi dang. Shut the shizzle up quizzle metus pizzle dolor iaculis auctor. Integer sagittizzle viverra urna. Curabitur ass ma nizzle quizzle pimpin'. Morbi venenatizzle ligula pimpin' amizzle tellus. Nizzle lobortis enim vitae arcu. Away socizzle natoque penatibus that's the shizzle magnizzle dizzle check it out montes, nascetizzle we gonna chung mizzle."
_gangsta[5] =
  "Rizzle nizzle erat stuff boofron. Nullizzle fo shizzle. Rizzle viverra laoreet check it out. Quisque doggy amet purizzle eu leo volutpat shit. Suspendisse potenti. Break it down rizzle sizzle vitae purus the bizzle own yo'. For sure gravida tempor ante. In interdum erat bling bling i saw beyonces tizzles and my pizzle went crizzle. Quisque malesuada. Nizzle yo tellus nizzle diam mollis tellivizzle. Nulla facilisi. Fo shizzle my nizzle quizzle fo izzle massa molestie pulvinar. Nullam gizzle dui check it out black. Get down get down sempizzle black sed gizzle. Etiam fo shizzle ass non owned. Maecenas rutrizzle fo shizzle purizzle."

const Randomizer = {
  sample(def) {
    let type = def.type || 'text'
    if (type === 'text') {
      if (/^(firstname|forename)$/i.test(def.name)) type = 'firstname'
      if (/^(lastname)$/i.test(def.name)) type = 'lastname'
      if (def.name === 'street') type = 'street'
    }

    // zipcode = autocomplete
    // currently zipcode sets city, country, county, lng, lat
    if (def.name === 'zipcode') type = 'zipcode'

    const gender = _.random(0, 1)

    // TODO autocomplete?
    switch (type) {
      case 'text':
        return _.sample(_gangsta).substr(0, _.random(20, 40))
      case 'textarea':
      case 'infotext':
        const counter = (def.size || 200) * 0.65
        return _.sample(_gangsta).substr(0, counter)
      case 'number':
        return _.random(def.min || 1, def.max || 500)
      case 'date':
        return _DATE_FROM.add(_.random(_DATE_DUR), 'd').format()
      case 'time':
        return `${_.random(8,20)}:00`
      case 'checkbox':
        return _.sample([false, true])
      case 'phone':
        return '+49 (0) 123 / 456 78 90'
      case 'email':
        return 'yourname@domain.suffix'
      case 'combobox':
        return _.sampleSize(def.items, 2)
      case 'slider':
        return _.random(def.min, def.max)
      case 'range':
        const range = def.max - def.min
        const rnd = _.random(1, range) / 2
        return [Math.round(def.min + rnd), Math.round(def.max - rnd)]
      case 'rating':
        return _.random(1, 5)
      case 'sparkline':
        def.size = def.size || 12
        def.min = def.min || 1
        def.max = def.max || 31
        return _.times(def.size, () => _.random(def.min, def.max))
      case 'firstname':
        return _.sample(gender ? FIRSTNAMES_F : FIRSTNAMES_M)
      case 'lastname':
        return _.sample(LASTNAMES)
      case 'street':
        return _.sample(STREET_1) + _.sample(STREET_2)
      case 'city':
        return _.sample(CITY)
      case 'zipcode':
        return _.sample(ZIPCODES)
      case 'switch':
        return _.random(0, 1) === 0
      default:
      // console.log('unhandled type', type)
    }

    return ''
  }
}

export default Randomizer
